import { useEffect } from 'react';
import { Navigate, useMatch } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import IntegrationList from 'components/IntegrationList';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { useStore } from 'models/Provider';

import IntegrationForm from './IntegrationForm';
import { NoIntegrations } from './NoIntegrations';
import { IntegrationsContentContainer, IntegrationsContent } from './styles';

function Integrations({ job }) {
  const match = useMatch('/jobs/:jobID/integrations/:integrationID/*');
  const { t } = useStore();
  useEffect(() => {
    job.loadIntegrations();
  }, [job]);

  if (job.integrationsState !== 'loaded') {
    return <Loading />;
  }
  if (job.integrations.length === 0) {
    return <NoIntegrations t={t} />;
  }

  const integrationID = Number(match?.params.integrationID);
  const integration = integrationID
    ? job.integrations.find((i) => i.triggerId === integrationID)
    : null;
  if (integrationID && !integration) {
    return <Navigate to={{ pathname: job.integrationsUrl }} />;
  }

  return (
    <PageContent scroll>
      <IntegrationsContentContainer>
        <IntegrationList
          activeId={integrationID}
          url={job.detailUrl}
          triggers={job.integrations}
          t={t}
        />
        <IntegrationsContent>
          {integration && (
            <IntegrationForm integration={integration} key={integration.triggerId} t={t} />
          )}
        </IntegrationsContent>
      </IntegrationsContentContainer>
    </PageContent>
  );
}

export default observer(Integrations);
